import React from 'react'

export default function DownIcon() {
  return (
    <svg viewBox='0 0 20 20' className='msl-arrow-icn'>
      <line
        stroke='currentColor'
        strokeLinecap='round'
        x1='10'
        y1='14'
        x2='4'
        y2='8'
      />
      <line
        stroke='currentColor'
        strokeLinecap='round'
        x1='16'
        y1='8'
        x2='10'
        y2='14'
      />
    </svg>
  )
}
